import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static values = {
    open: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    if (this.openValue) this.open()
    this.element.addEventListener(
      'turbo:frame-missing',
      this.#handleFrameMissing
    )
  }

  disconnect() {
    this.element.removeEventListener(
      'turbo:frame-missing',
      this.#handleFrameMissing
    )
  }

  open(e) {
    e.preventDefault()
    e.stopPropagation()
    document.body.insertAdjacentHTML('beforeend', this.contentTarget.innerHTML)
    document.body.classList.add('overflow-hidden') // prevent scroll on body
  }

  dismiss() {
    // allow scroll on body on dismiss if this is the last open modal
    if (this.#openModals.length <= 1) {
      document.body.classList.remove('overflow-hidden')
    }
    this.element.remove()
  }

  #handleFrameMissing = (event) => {
    event.preventDefault()
    this.dismiss()
    event.detail.visit(event.detail.response)
  }

  get #openModals() {
    return document.querySelectorAll(
      "body > [data-controller='kaia--modal-component']"
    )
  }
}
